module.exports = __webpack_public_path__ + "img/Slide13.d5b76ae7.png";